import { AiFillHome } from 'react-icons/ai';
import { IoSettings } from 'react-icons/io5';
import {
  FaMessage,
  FaUsers,
  FaCircleDollarToSlot,
  FaWallet,
  FaPassport,
  FaGift,
} from 'react-icons/fa6';
import { FaMailBulk, FaBook } from 'react-icons/fa';
import { BsBank2, BsCurrencyExchange } from 'react-icons/bs';
import { GiProfit } from 'react-icons/gi';

export const sidebarLinks = [
  {
    name: `Overview`,
    icon: <AiFillHome />,
    index: 1,
    link: `/dashboard/overview`,
  },
  {
    name: `Users`,
    icon: <FaUsers />,
    link: `/dashboard/users`,
  },
  {
    name: `Deposits`,
    icon: <FaCircleDollarToSlot />,
    link: `/dashboard/deposits`,
  },
  {
    name: `Bank Withdrawals`,
    icon: <BsBank2 />,
    link: `/dashboard/bank-withdrawals`,
  },
  {
    name: `Crypto Withdrawals`,
    icon: <BsCurrencyExchange />,
    link: `/dashboard/crypto-withdrawals`,
  },
  {
    name: `Profits`,
    icon: <GiProfit />,
    link: `/dashboard/profits`,
  },
  {
    name: `Bonus`,
    icon: <FaGift />,
    link: `/dashboard/bonus`,
  },
  {
    name: `KYCs`,
    icon: <FaPassport />,
    link: `/dashboard/kyc`,
  },
  {
    name: `Messages`,
    icon: <FaMessage />,
    link: `/dashboard/messages`,
  },
  {
    name: `Bulk Emails`,
    icon: <FaMailBulk />,
    link: `/dashboard/bulk-emails`,
  },
  {
    name: `Trading Plans`,
    icon: <FaBook />,
    link: `/dashboard/trading-plans`,
  },
  {
    name: `Wallets`,
    icon: <FaWallet />,
    link: `/dashboard/wallets`,
  },
  {
    name: `Settings`,
    icon: <IoSettings />,
    link: `/dashboard/settings`,
  },
];
